import { type Participant, renderParticipantName } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import * as htmlToImage from 'html-to-image';
import React from 'react';
import { useAppContext } from '../../hooks/useAppContext';
import { ParticipantQRCode } from './ParticipantQRCode';

interface Props extends ChakraV3.ButtonProps {
  qrId: string;
  participant: Participant;
}

export const ParticipantQRCopyImageButton = (props: Props) => {
  const { qrId, participant, children, ...rest } = props;

  const { organization, successToast, errorToast } = useAppContext();
  const ref = React.useRef<HTMLDivElement>(null);

  const handleCopy = async () => {
    if (ref.current) {
      const dataUrl = await htmlToImage.toPng(ref.current, {
        pixelRatio: 5,
      });
      const blob = await (await fetch(dataUrl)).blob();
      try {
        const item = new ClipboardItem({ 'image/png': blob });
        await navigator.clipboard.write([item]);
        successToast('QR code image copied to clipboard');
      } catch (error) {
        errorToast('Failed to copy QR code image to clipboard. Not supported on Safari or Firefox');
      }
    }
  };

  return (
    <>
      <ChakraV3.Stack pos='absolute' zIndex={-1}>
        <ChakraV3.Stack ref={ref} align='center' p={2}>
          <ParticipantQRCode qrId={qrId} />
          <ChakraV3.Stack gap={0} textAlign='center'>
            <ChakraV3.Text fontSize='md' fontWeight='bold'>
              {renderParticipantName(participant)}
            </ChakraV3.Text>
            <ChakraV3.Text fontSize='xs' fontWeight='bold'>
              {organization.name}
            </ChakraV3.Text>
          </ChakraV3.Stack>
        </ChakraV3.Stack>
      </ChakraV3.Stack>
      <ChakraV3.Button size='xs' w='fit-content' onClick={handleCopy} {...rest}>
        {children}
      </ChakraV3.Button>
    </>
  );
};
